export default {
  namespaced: true,

  state: {
    data: {
      openModal: false,
    },
  },

  // TODO: remove all from this modals to put in-component modals
  getters: {
    getIsOpenModal: (state) => state.data.openModal,
  },

  actions: {
    setOpenModal({ commit }, payload) {
      const isOpenModal = payload;
      commit("SET_OPEN_MODAL", isOpenModal);
    },
  },

  mutations: {
    SET_OPEN_MODAL(state, data) {
      state.data.openModal = data;
    },
  },
};
